/**
 * SaleDashboardContainer
 * --
 */
import React from 'react';
import { useUserStack } from 'store';
import SaleDashboard from 'routes/admin.routes/admin.sale/SaleDashboard';

/**----------------------------------------
 * [Component] 쇼핑몰관리자: 매출관리 컨테이너
 * ----------------------------------------
 */
const SaleDashboardContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();

  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <SaleDashboard
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default SaleDashboardContainer;
